import { Tooltip } from "@mui/material";
import { RxCross2 } from "react-icons/rx";
import "./conservationgallery.scss";

const ConservationGallery = ({ technicalImages, setShowS3Gallery }) => {
  return (
    <div
      style={{
        zIndex: "1",
        position: "sticky",
        height: "225px",
        width: "100%",
        backgroundColor: "#f6f6f7",
        paddingTop: "5px",
        overflowX: "hidden",
        alignItems: "flex-start",
      }}
      className="drive_img_div"
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          position: "sticky",
          top: "5px",
          marginBottom: "5px",
        }}
      >
        <Tooltip title="Close gallery">
          <div
            style={{
              marginRight: "27px",
              padding: "8px",
              display: "flex",
              borderRadius: "50%",
              backgroundColor: "#fff",
            }}
            onClick={() => setShowS3Gallery(false)}
          >
            <RxCross2 style={{ fontSize: "23px" }} />
          </div>
        </Tooltip>
      </div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          width: "93%",
        }}
      >
        {technicalImages.map((file, index) => {
          return (
            <div
              key={index}
              className="drive_photo_div_"
              draggable
              onDragStart={(e) => {
                const imageUrl = file.s3_file;

                const jsonData = JSON.stringify({
                  imageUrl,
                  thumbnailUrl: imageUrl,
                  caption: file.file_name,
                });
                e.dataTransfer.setData("application/json", jsonData);
                e.dataTransfer.setData("text/plain", jsonData);

                const imgElement =
                  e.target.tagName === "IMG"
                    ? e.target
                    : e.target.querySelector("img");
                if (imgElement && imgElement.complete) {
                  e.dataTransfer.setDragImage(
                    imgElement,
                    imgElement.width / 2,
                    imgElement.height / 2
                  );
                }
              }}
            >
              <img
                src={file.s3_file}
                alt={file.name || `media-${index}`}
                className="drive_img"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ConservationGallery;
